import React, { CSSProperties } from "react";
import { Button, Typography } from "@mui/material";
import styled from "styled-components";

const CustomButton = styled(Button)`
  padding: 20px;
  margin-right: 10px;

  &.selected {
    background-color: rgba(33, 37, 41, 0.3);
  }
`;

interface ISimpleButtonProps {
  size: "small" | "medium" | "large";
  onClick: () => void;
  text: string;
  selected?: boolean;
  style?: CSSProperties;
}

const SimpleButton: React.FC<ISimpleButtonProps> = (props) => {
  const { text, size, onClick, selected = false, style } = props;

  return (
    <CustomButton
      variant="outlined"
      size={size}
      onClick={onClick}
      className={selected ? "selected" : ""}
      style={style ? style : {}}
    >
      <Typography variant="button">{text}</Typography>
    </CustomButton>
  );
};

export default SimpleButton;
